export default "__VITE_ASSET__CZMViC2B__"